import Customers from "../../pages/Administration/Customers";
import ShortCodes from "../../pages/Administration/ShortCodes";
import CustomerDetail from "../../pages/Administration/CustomerDetail";
import Keywords from "../../pages/Administration/Keywords";
import ShortLinksAdmin from "../../pages/Administration/ShortLinksAdmin";
import CampaignsAdmin from "../../pages/Administration/CampaignsAdmin";
import MaskShortCodes from "../../pages/Administration/MaskShortCodes";
import UsersByPartner from "../../pages/Customer/users";
import SmsPackages from "../../pages/Configuration/SmsPackages";
import OperativeUsers from "../../pages/Configuration/OperativeUsers";
import NewCampaignAdmin from "../../pages/Administration/_NewCampaignAdmin";
import NewCampaignAdminV2 from "../../pages/Administration/NewCampaignAdmin";
import { createProtectedRoutes } from "../../utils/createdProtectedRoutes";
import CustomerAgentDevices from "../../pages/Administration/customers/agents/CustomerAgentDevices";
export const ROUTE = "Administration";

const routesConfig = [
  { path: `${ROUTE}/Customers`, component: Customers, roles: [1] },
  { path: `${ROUTE}/keywords`, component: Keywords, roles: [1] },
  { path: `${ROUTE}/ShortLinks`, component: ShortLinksAdmin, roles: [1, 5] },
  { path: `${ROUTE}/Campaigns`, component: CampaignsAdmin, roles: [1, 5] },
  { path: `${ROUTE}/shortcodesmasks`, component: MaskShortCodes, roles: [1] },
  { path: `${ROUTE}/shortcodes`, component: ShortCodes, roles: [1] },
  { path: `${ROUTE}/Users`, component: UsersByPartner, roles: [1, 2] },
  { path: `${ROUTE}/smspackages`, component: SmsPackages, roles: [1] },
  { path: `${ROUTE}/Staff`, component: OperativeUsers, roles: [1] },
  {
    path: `${ROUTE}/NewCampaignAdmin`,
    component: NewCampaignAdmin,
    roles: [1, 5],
  },
  { path: `Customer/Details/:id`, component: CustomerDetail, roles: [1] },
  {
    path: `Customer/Details/:partnerId/agents/devices/:vcPartner`,
    component: CustomerAgentDevices,
    roles: [1],
  },
  {
    path: `${ROUTE}/NewCampaignAdminV2`,
    component: NewCampaignAdminV2,
    roles: [1, 5],
  },
];

const administrationRoutes = createProtectedRoutes(routesConfig);

export default administrationRoutes;
